export const theme = {
  color: {
    black: '#000000',
    blackrussian: '#171725',
    dodgerblue: '#027EFC',
    dodgerblueTransparent: '#027EFC1A',
    white: '#FFFFFF',
    linkwater: '#CED6E0',
    dimgrey: '#666666',
    radicalred: '#FF3C4C',
    goldenyellow: '#FFEC00',
    goldenyellowTransparent: '#FFEC0066',
    freespeechgreen: '#11D000',
    neoncarrot: '#FD9C3C',
    lightslateblue: '#7979FD',
    whitesmoke: '#F6F6F6',
    lavender: '#EDEDF4',
    quartz: '#E2E2EA',
    shuttlegrey: '#57606F',
    sunshade: '#FFA047',
    solitude: '#B5B5BE',
    boxshadow: '#231F4314'
  },
  typography: {
    h1: `
      font-size: 40px;
      font-weight: 500;
      line-height: 48px;
      font-family: e-Ukraine;
    `,
    h2: `
      font-size: 32px;
      font-weight: 500;
      line-height: 40px;
      font-family: e-Ukraine;
    `,
    h3: `
      font-size: 24px;
      font-weight: 500;
      line-height: 32px;
      font-family: e-Ukraine;
    `,
    h4: `
      font-size: 18px;
      font-weight: 500;
      line-height: 24px;
      font-family: e-Ukraine;
    `,
    h5: `
      font-size: 18px;
      font-weight: 400;
      line-height: 24px;
      font-family: e-Ukraine;
    `,
    h6: `
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      font-family: e-Ukraine;
    `,
    h7: `
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      font-family: e-Ukraine;
    `,
    status: `
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-transform: uppercase;
      font-family: e-Ukraine;
    `,
    p1: `
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      font-family: e-Ukraine;
    `,
    p2: `
      font-size: 14px;
      font-weight: 300;
      line-height: 20px;
      font-family: e-Ukraine;
    `,
    p3: `
      font-size: 12px;
      font-weight: 400;
      line-height: 14px;
      font-family: e-Ukraine;
    `,
    p4: `
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;
      font-family: e-Ukraine;
    `,
    p5: `
      font-size: 10px;
      font-weight: 400;
      line-height: 12px;
      font-family: e-Ukraine;
    `,
    p6: `
      font-size: 10px;
      font-weight: 300;
      line-height: 12px;
      font-family: e-Ukraine;
    `,
    link: `
      font-size: 14px;
      font-weight: 300;
      line-height: 16px;
      color: #027EFC;
      text-decoration: none;
      cursor: pointer;
      font-family: e-Ukraine;
    `
  },
  resolution: {
    apple: '1440px',
    xxxl: '1360px',
    xxl: '1200px',
    xl: '1024px',
    lg: '992px',
    mdx: '840px',
    md: '768px',
    sm: '640px',
    smx: '480px',
    xs: '320px'
  },
  breakpoint: {
    apple: 1440,
    xxxl: 1360,
    xxl: 1200,
    xl: 1024,
    lg: 992,
    mdx: 840,
    md: 768,
    sm: 640,
    smx: 480,
    xs: 320
  },
  mediaQuery: {
    homepage: '(max-width: 640px) and (max-height: 992px), (max-width: 992px) and (max-height: 640px)'
  }
} as const

export type ThemeColor = keyof typeof theme.color
